import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Trade delivery'

  }
];

@Component({
  selector: 'page-trade-delivery',
  templateUrl: './trade-delivery.html',
  styleUrls: ['./trade-delivery.scss']
})

export class PageTradeDelivery implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  customerCtrl: FormControl;
  fetchCustomer=[];
  filteredCustomers: any;
  customers = [];
  rows = [];
  temp = [];
  model=[];
  items=[];
  form: FormGroup;
  key:any="";keypart:any="";
  productCtrl:FormControl;
  poCtrl:FormControl;
  productModels=[];
  filteredProducts:any;
  loadingIndicator: boolean = true;
  sysPath:String=environment.sysPath;
  sysPathPrint:String=environment.sysPath+"/api/product-list-print.php";
  sysPathExport:String=environment.sysPath+"/api/product-list-export.php";
  kbFilter:boolean=true;dateFilter:boolean=true;sale:boolean=true;collect:boolean=true;packing:boolean=true;qg2:boolean=true;finalCk:boolean=true;
  pd:boolean=true;rm:boolean=true;
  date_selected:any;
  partno:String;
  pono:String;
  kbno:String;
  constructor(private fb: FormBuilder,private httpservice:httpservice,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {
    let date = new Date();
    this.date_selected = date.toISOString().split('T')[0];
    this.getProduct();
    this.getStartData();
   // console.log('-------this.filteredStates-----',this.filteredStates);
    this._sharedService.emitChange(this.pageTitle);
  }

  getStartData(){
    this.httpservice.fetchget('getJSON_product.php?keypart='+this.keypart+'&key='+this.key,(data)=>{
      this.temp = [...data];
      this.rows = data;
      setTimeout(() => { this.loadingIndicator = false; }, 1500);
  });
  }

  onlyDatefilter(e){
    if(e.checked){
      this.dateFilter = true;
    }else{
      this.dateFilter = false;
    }
  }
  onlyKbfilter(e){
    if(e.checked){
      this.kbFilter = true;
    }else{
      this.kbFilter = false;
    }
  }
  saleFilter(e){
    if(e.checked){
      this.sale = true;
    }else{
      this.sale = false;
    }
  }
  collectFilter(e){
    if(e.checked){
      this.collect = true;
    }else{
      this.collect = false;
    }
  }
  packingFilter(e){
    if(e.checked){
      this.packing = true;
    }else{
      this.packing = false;
    }
  }
  qg2Filter(e){
    if(e.checked){
      this.qg2 = true;
    }else{
      this.qg2 = false;
    }
  }
  finalFilter(e){
    if(e.checked){
      this.finalCk = true;
    }else{
      this.finalCk = false;
    }
  }
  pdFilter(e){
    if(e.checked){
      this.pd = true;
    }else{
      this.pd = false;
    }
  }
  rmFilter(e){
    if(e.checked){
      this.rm = true;
    }else{
      this.rm = false;
    }
  }

  print(){
    const printContent = document.getElementById("print-section");
    const WindowPrt = window.open('', '', 'left=0,top=0,width=700,height=400,toolbar=0,scrollbars=0,status=0');

    WindowPrt.document.write('<title>trade-back-report-' + this.date_selected + '</title>');
    WindowPrt.document.write('<link rel="stylesheet" type="text/css" href="'+this.sysPath+'/assets/css/bootstrap.css">');
    WindowPrt.document.write('<link rel="stylesheet" type="text/css" href="'+this.sysPath+'/assets/css/bootstrap.min.css">');
    WindowPrt.document.write(printContent.innerHTML);
    WindowPrt.document.close();
    WindowPrt.onload = function() {
    WindowPrt.focus();
    WindowPrt.print();
    WindowPrt.close();
    };
}//end print

  getProduct(){
    this.httpservice.fetchget('getJSON_product.php?',(productModel) => {
      this.productModels = productModel.map(function (val) {
        return [val.tp_part_no]
      });
      console.log('------this.product------', this.productModels);
    });
    this.productCtrl = new FormControl();
    this.filteredProducts = this.productCtrl.valueChanges
    .startWith(null)
    .map(val => {

      if (isArray(val)) {
        this.partno = val[0];
        //this.poCtrl.setValue(val[0]);
      } else {
        this.partno = val;
        //this.poCtrl.setValue(val);
      }
      console.log('------val------',this.key);
         return val ? this.productModels.filter((s) => new RegExp(val, 'gi').test(s)) : this.productModels;
    });
  }

    search(){
      this.pono = this.form.controls.poNo.value;
      this.kbno = this.form.controls.kbNo.value;

      if(this.kbFilter==true){
        if(this.form.controls.kbNo.value!=null && this.form.controls.poNo.value!=null && this.partno!=null){
          let dialogRef = this.dialog.open(tradeDialog, { disableClose: true });
          let instance = dialogRef.componentInstance;
          instance.Message = "wait.....";
          this.getSale(this.dateFilter,this.kbFilter,this.kbno,this.pono,this.partno,this.date_selected).then(data=>{
            console.log('data',data);
            this.items = data;
            this.productCtrl.reset();
            this.form.reset();
            this.dialog.closeAll();
            console.log('xxxxx');
    
          });

        }else{
          this.warningDialog('Put Kanban No , PO No , Par No.');
        }
      }else{

        if(this.form.controls.poNo.value!=null && this.partno!=null){
          let dialogRef = this.dialog.open(tradeDialog, { disableClose: true });
          let instance = dialogRef.componentInstance;
          instance.Message = "wait.....";
          this.getSale(this.dateFilter,this.kbFilter,this.kbno,this.pono,this.partno,this.date_selected).then(data=>{
            console.log('data',data);
            this.items = data;
            this.productCtrl.reset();
            this.form.reset();
            this.dialog.closeAll();
            console.log('xxxxx');
    
          });
        }else{
          this.warningDialog('Put PO No , Par No.');
        }


      }

      }

  ngOnInit() {
    this.form = this.fb.group({
        poNo: [null, Validators.compose([Validators.required])],
        kbNo: [null, Validators.compose([Validators.required])]
    });

  }

  getSale(df:any,kbf:any,kb:any,po:any,partno:any,date_selected:any){
    let self = this;
    return new Promise<any>(function(resolve,reject){
      try{
        self.httpservice.fetchget('getJSON_trade_back.php?df='+df+'&kbf='+kbf+'&kb='+kb+'&process=sale&partno='+partno+'&pono='+po+'&date_selected='+date_selected,data=>{
          return resolve(data);
        })
      }catch(e){
          return reject(e);
      }
    });
  }

  getCollect(po:any,partno:any,date_selected:any){
    let self = this;
    return new Promise<any>(function(resolve,reject){
      try{
        self.httpservice.fetchget('getJSON_trade_back.php?process=collect&partno='+partno+'&pono='+po+'&date_selected='+date_selected,data=>{
          return resolve(data);
        })
      }catch(e){
          return reject(e);
      }
    });
  }

  getPacking(po:any,partno:any,date_selected:any){
    let self = this;
    return new Promise<any>(function(resolve,reject){
      try{
        self.httpservice.fetchget('getJSON_trade_back.php?process=packing&partno='+partno+'&pono='+po+'&date_selected='+date_selected,data=>{
          return resolve(data);
        })
      }catch(e){
          return reject(e);
      }
    });
  }

  getQg2(po:any,partno:any,date_selected:any){
    let self = this;
    return new Promise<any>(function(resolve,reject){
      try{
        self.httpservice.fetchget('getJSON_trade_back.php?process=qg2&partno='+partno+'&pono='+po+'&date_selected='+date_selected,data=>{
          return resolve(data);
        })
      }catch(e){
          return reject(e);
      }
    });
  }

  getFinal(po:any,partno:any,date_selected:any){
    let self = this;
    return new Promise<any>(function(resolve,reject){
      try{
        self.httpservice.fetchget('getJSON_trade_back.php?process=final&partno='+partno+'&pono='+po+'&date_selected='+date_selected,data=>{
          return resolve(data);
        })
      }catch(e){
          return reject(e);
      }
    });
  }
  getPd(po:any,partno:any,date_selected:any){
    let self = this;
    return new Promise<any>(function(resolve,reject){
      try{
        self.httpservice.fetchget('getJSON_trade_back.php?process=pd&partno='+partno+'&pono='+po+'&date_selected='+date_selected,data=>{
          return resolve(data);
        })
      }catch(e){
          return reject(e);
      }
    });
  }
  getRm(po:any,partno:any,date_selected:any){
    let self = this;
    return new Promise<any>(function(resolve,reject){
      try{
        self.httpservice.fetchget('getJSON_trade_back.php?process=rm&partno='+partno+'&pono='+po+'&date_selected='+date_selected,data=>{
          return resolve(data);
        })
      }catch(e){
          return reject(e);
      }
    });
  }

  warningDialog(message: string) {
    let dialogRef = this.dialog.open(WarningTradBackDialog);
    let instance = dialogRef.componentInstance;
    instance.message = message;
    instance.title = "Warning";

    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;

      if (result === '1') {

        // alert('postString');
      } else {
        console.log('---result---', result);
        // alert('cancel');
      }

    });
  }

}
//warning
@Component({
  selector: 'warning-trad-back-dialog',
  templateUrl: 'warning.html',
})
export class WarningTradBackDialog {
  title = '';
  message = '';
  constructor(public dialogRefWarning: MdDialogRef<WarningTradBackDialog>) { }
}
//dialog
@Component({
  selector: 'loading-dialog',
  templateUrl: 'loading-dialog.html',
})
export class tradeDialog {
  public Message = 'Loading data...';
  constructor(public dialogRef: MdDialogRef<tradeDialog>) {}
}




// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/trade-back/trade-delivery.ts